import { Alert } from '@amzn/awsui-components-core';
import React from 'react';

interface Props {
  userName: string;
}

const WorkflowLockInfo = ({ userName }: Props) => {
  return (
    <Alert type="warning">
      {`This content is currently being edited by ${userName ? userName : 'another user'}. It will become available for editing and adding new inline commenting when the user finishes their work.`}
    </Alert>
  );
};

export default WorkflowLockInfo;
